import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import demandServices from '@src/services/demands/demands.services';

export const getVehicleActivityLogs = createAsyncThunk(
  'getVehicleActivityLogs',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { pageNumber = 1, pageSize = 10, customerId = null, filter = null } = body;
      const res = await demandServices.getVehicleActivityLogs({
        pageNumber,
        pageSize,
        customerId,
        filter,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  demandList: [],
  statusList: [],
  requestorList: [],
  requestTypeList: [],
  providerList: [],
  loading: {
    vehicleList: false,
    vehicleLimitsList: false,
    vehiclesUsableDays: false,
  },
  pagedProperty: {
    pageSize: 0,
    totalItems: 0,
    currentPage: 1,
  },
};

export const demandsSlice = createSlice({
  name: 'demands',
  initialState,
  reducers: {
    resetCurrentLoadVehicleManagement: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleActivityLogs.pending, (state) => {
        state.loading.demandList = true;
      })
      .addCase(getVehicleActivityLogs.fulfilled, (state, action) => {
        state.loading.demandList = false;
        state.deviceTypeList = action?.payload?.data?.deviceTypeList || [];
        state.providerList = action?.payload?.data?.providerList || [];
        state.requestTypeList = action?.payload?.data?.requestTypeList || [];
        state.requestorList = action?.payload?.data?.requestorList || [];
        state.statusList = action?.payload?.data?.statusList || [];
        state.demandList = action?.payload?.data?.vehicleActivityLogResponseItemList || [];
        state.pagedProperty.pageSize = action?.payload?.pageSize || 0;
        state.pagedProperty.totalItems = action?.payload?.totalItems || 0;
        state.pagedProperty.currentPage = action?.payload?.currentPage || 1;
      })
      .addCase(getVehicleActivityLogs.rejected, (state, action) => {
        state.loading.demandList = false;
        state.demandList = [];
        state.statusList = [];
        state.requestorList = [];
        state.requestTypeList = [];
        state.providerList = [];
        state.deviceTypeList = [];
        state.pagedProperty = {
          pageSize: 0,
          totalItems: 0,
          currentPage: 1,
        };
        state.error = action.payload || 'Error';
      });
  },
});

export const { resetCurrentLoadVehicleManagement } = demandsSlice.actions;
